import AppApi from './AppApi'
import * as config from '../config.js'
var Api = new AppApi({
  url: config.API_ROOT
})

export default Api
